import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import staticFilesUrl from 'constants/staticFiles'
import { imageLoad } from 'utils/image'
import styled from 'styled-components'

const ImgWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background-color: #f6f4f3;
`
const AdImage = ({ imgSrc, fade }) => {
  const [src, setSrc] = useState()
  const [loading, setLoading] = useState(true)
  const [isFallbackImage, setIsFallbackImage] = useState()

  useEffect(() => {
    imageLoad({
      src: imgSrc,
      onLoad: () => {
        setSrc(imgSrc), setLoading(false), setIsFallbackImage(false)
      },
      onError: () => {
        setSrc(`${staticFilesUrl}/assets/images/no-image.svg`),
          setLoading(false),
          setIsFallbackImage(true)
      },
    })
  }, [imgSrc])

  return (
    <ImgWrapper>
      <img
        style={{
          opacity: loading ? 0 : fade ? 0.6 : 1,
          width: '100%',
          height: '100%',
          borderRadius: '2px',
          objectFit: isFallbackImage ? 'scale-down' : 'cover',
        }}
        alt="Annonsbild"
        src={src}
      />
    </ImgWrapper>
  )
}

AdImage.propTypes = {
  imgSrc: PropTypes.string,
  fade: PropTypes.bool,
}

export default AdImage
